export default {
  N02a_SDKP_DVDT_ND112020_Update: 'N02a_SDKP_DVDT_ND112020_Update',
  N02a_SDKP_DVDT_ND112020_UpdateDynamic: 'N02a_SDKP_DVDT_ND112020_UpdateDynamic',
  N02a_SDKP_DVDT_ND112020: 'N02a_SDKP_DVDT_ND112020',
  N02a_SDKP_DVDT_Dynamic_ND112020: 'N02a_SDKP_DVDT_Dynamic_ND112020',
};
